type SegmentDuplicateGuardEnv = {
  DEV: boolean
  VITE_SEGMENT_DEDUPE_DISABLED?: string
}

export const isSegmentDuplicateGuardDisabledByEnv = (
  env: SegmentDuplicateGuardEnv
): boolean => !env.DEV || env.VITE_SEGMENT_DEDUPE_DISABLED === 'true'

export const isSegmentDuplicateGuardEnabled = (): boolean =>
  !isSegmentDuplicateGuardDisabledByEnv(import.meta.env)
